import moment from 'moment';

export const getBillInfoMessageByAttr = (bill: any, attr: string): string => {
  switch (attr) {
    case 'paid_time':
    case 'created_time':
    case 'valid_time_start':
    case 'valid_time_end':
      const date = moment(bill[attr]);
      if (!date.isValid()) {
        return '';
      }

      return moment(bill[attr]).format('YYYY-MM-DD HH:mm:ss');
    case 'play_time':
      const start = moment(bill.valid_time_start);
      const end = moment(bill.valid_time_end);

      if (!start.isValid() || !end.isValid()) {
        return '';
      }

      return (
        `${start.format('YYYY年MM月DD日 周d HH:mm-')
                + end.format('HH:mm')
        }(${
          end.diff(start, 'hour')
        }h)`
      );
    default:
      return bill[attr];
  }
};
